import type { FC, ReactElement } from "react"
import { ErrorMessageFallback } from "../components/errors/ErrorMessageFallback"
import { ErrorBoundary } from "../components/errors/ErrorBoundary"

export function withErrorBoundary<P = NonNullable<unknown>>(fallbackFn: () => ReactElement | null = () =>
	<ErrorMessageFallback />) {
	return (C: FC<P>) => {
		function WithErrorBoundary(componentProps: P) {

			return (
				<ErrorBoundary fallback={fallbackFn()}>
					{// @ts-expect-error чтобы не ругалась проверка ts
						<C {...componentProps} />
					}
				</ErrorBoundary>
			)
		}

		WithErrorBoundary.displayName = "WithErrorBoundary_" + (C.displayName ?? C.name)

		return WithErrorBoundary
	}
}